import React from 'react';
import PropertyTypes from 'src/enums/propertyTypes';
import Colors from 'src/themes/brickx/colors';
import styled from 'styled-components';

const colorMapping = {
  [PropertyTypes.house]: Colors.primary,
  [PropertyTypes.unit]: Colors.primary,
  [PropertyTypes.multiunit]: Colors.primary,
  [PropertyTypes.multihouse]: Colors.primary,
  [PropertyTypes.farm]: Colors.blue900,
  [PropertyTypes.offices]: Colors.blue900,
  [PropertyTypes.development]: Colors.blue900,
  [PropertyTypes.commercial]: Colors.blue900,
  [PropertyTypes.securedDebt]: Colors.greenDark,
  [PropertyTypes.unsecuredDebt]: Colors.greenDark,
  [PropertyTypes.diversifiedDebt]: Colors.greenDark,
  [PropertyTypes.equityFund]: Colors.yellow600,
  [PropertyTypes.debtFund]: Colors.yellow600,
  [PropertyTypes.diversifiedFund]: Colors.yellow600,
};

const Layout = styled.div`
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 1.2rem;
  font-weight: 800;
  background-color: ${(props) => props.bgColor || Colors.primary};
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const PropertyTypeChip = ({ property }) => {
  return (
    <Layout bgColor={colorMapping[property.propertyType]}>
      {property.propertyType}
    </Layout>
  );
};

export default PropertyTypeChip;
